<template>
  <div class="page-width">
    <div v-if="login && !loggingIn && !signInAsGuest" class="sign-container">
      <div class="mobile-signin-header">
        <h2 class="mobile-registered"><span class="first-word">Registered</span> Customers</h2>
        <p class="mobile-signin-note">If you have an account, sign in with your email address.</p>
        <p class="mobile-signin-note">Asian Food Grocer has a new look! If you're coming from our old site, please reset your password below.</p>
      </div>
      <p v-if="loginErrorMessage " class="invalid-credentials">
        {{ loginErrorMessage }}
      </p>
      <el-form class="form-container" :model="signUpForm" @keyup.enter.native="Login(signUpForm)">
        <el-input :style="'border-radius:7px;'" placeholder="Email Address" class="signup-modal-input" v-model="signUpForm.username"></el-input>
        <el-input :style="'border-radius:7px;'" placeholder="Password" class="signup-modal-input" v-model="signUpForm.password" type="password"></el-input>
      </el-form>
      <div class="text-center">
        <p @click="ForgotPassword" class="pointer" >{{ $t('forgotPassword') }}</p>
        <p @click="guestSignUp" class="pointer" >Checkout as Guest</p>
        <p>
          <button class="signin" @click="Login(signUpForm)">{{ $t('signIn') }}</button>
        </p>
      </div>
    </div>
    <div class="sign-container" v-else-if="loggingIn">
      <loading />
    </div>
    <div v-else-if="!login && !showModal && !showChangeToNewPassword && !signInAsGuest" class="sign-container">
      <div class="text-center">
        <h4 class="business-header">{{ $t('resetPassword') }}</h4>
        <p class="business-info-mobile">{{ $t('resetSendEmail') }}</p>
        <p v-if="couldNotFindEmail" style="color: red">{{ $t('noAccountWithEmail') }}</p>
      </div>
      <el-form class="form-container" label-width="80px">
        <el-input class="register-modal-input" @keyup.native.enter="resetEmailRequest(email, $event)" placeholder="Email" v-model="email"></el-input>
        <input :style="'display: none'"></input>
      </el-form>
      <div class="text-center">
        <p @click="ForgotPassword" class="pointer" >Back to Sign In</p>
        <p>
          <button class="signin" @click="resetEmailRequest(email, $event)">{{ $t('submit') }}</button>
        </p>
    </div>
  </div>
    <transition name="modal" v-else-if="showModal && !login">
      <div class="sign-container">
        <div class="form-container">
          <p>We have sent a verification code to the desired email address.</p>

            <!-- <p style="font-size: 14px; color: red; margin-top: 10px" v-if="verificationCodeFail">{{ $t('codeNoMatch') }}</p> -->
            <p style="font-size: 14px; color: red; margin-top: 10px" v-if="verificationCodeFail">{{ verificationFailReason }}</p>

            <p style="font-size: 15px; margin-top: 10px; margin-bottom: 5px;">{{ $t('verification_code') }}: </p><el-input style="margin-bottom: 20px;" autofocus=true placeholder="Verification Code" v-model="verification"></el-input>
            <p style="font-size: 15px; margin-bottom: 5px;">{{ $t('new_password') }}: </p><el-input style="margin-bottom: 20px;" placeholder="New Password" v-model="newPW"></el-input>
            <p style="font-size: 15px; margin-bottom: 5px;">{{ $t('confirm_password') }}: </p><el-input style="margin-bottom: 30px;" placeholder="Confirm New Password" v-model="confirmPW"></el-input>          
           
            <p style="font-size: 14px; color: red; margin-top: 10px" v-if="displaySameError">{{ $t('passwordsNotMatch') }}</p>

            <div class="button-container">
            <el-button class="cancel-verification" @click="cancelEnteringVerificationCode">{{ $t('cancel') }}</el-button>
            <el-button class="send-verification" :disabled="!verification || !newPW || !confirmPW" @click="sendVerificationCode(verification, newPW, confirmPW)">{{ $t('submit') }}</el-button>
          </div>
        </div>
      </div>
    </transition>
    <transition name="modal2" v-else-if="showChangeToNewPassword && !login && !showModal" >
      <div class="sign-container">      
        <div class="form-container">
          <h4 class="business-header" :style="'padding-bottom: 10px'">{{ $t('enterNewPassword') }}</h4>
          <p v-if="resetPasswordErrors.length" style='padding-bottom: 20px'>
            <ul style="color: red">
              <li v-for="error in resetPasswordErrors">{{ error }}</li>
            </ul>
          </p>
          <el-form class="reset-password-form" :model="resetPasswordForm">
            <el-input class="register-modal-input" autofocus=true placeholder="New Password" type='password' v-model="resetPasswordForm.newPassword"></el-input>
            <el-input class="register-modal-input" autofocus=true placeholder="Confirm New Password" type='password' v-model="resetPasswordForm.confirmNewPassword"></el-input>
        </el-form>
          <div class="button-container">
            <el-button  class="signin" @click="resetPasswordRequest(resetPasswordForm)">{{ $t('submit') }}</el-button>
          </div>
        </div>
      </div>
    </transition>
    <div class="sign-container" v-else-if="login && signInAsGuest && !showModal && !loggingIn ">
      <div class="form-container">
        <h2 class="mobile-registered" :style="'padding-bottom: 10px'" >Enter Email Address to Sign in as Guest</h2>
          <p class="mobile-registered-note" >Please use a valid email in order to track and check your order status.</p>
          <p v-if="guestCheckoutErrors.length" class="guestCheckout-container">
            <b class="following-errors">{{ $t('followingErrors') }}</b>
            <ul class="guestCheckout-errors">
              <li v-for="error in guestCheckoutErrors">{{ error }}</li>
            </ul>
          </p>
        <el-input :style="'border-radius:7px;'" placeholder="Email" class="signup-modal-input" v-model="guestSignUpEmail" ></el-input>
        <p @click="guestSignUp" class="pointer" >Back to Login</p>
        <el-button class="signin" @click="guestLogIn()">{{ $t('submit') }}</el-button>
      </div>
    </div>
  </div>
</template>
​
​<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { isUserAuthenticated } from '../../store/modules/cart';
import loading from '../loading';
export default {
  name: 'confirmation',
  components: {
    loading
  },
  data() {
    return {
      errors: [],
      businessErrors: [],
      guestCheckoutErrors: [],
      signUpForm: {
        username: '',
        password: '',
      },
      registerForm: {
        FirstName: '',
        LastName: '',
        email: '',
        password:'',
        username: '',
        confirmPassword: '',
      },
      b2bFirstName: '',
      b2bLastName: '',
      email: '',
      login: true, // true showlogin; false forget password
      showModal: false,
      showChangeToNewPassword: false,
      newPasswordResetMessage: '',
      verification: '',
      newPW: '',
      confirmPW: '',
      displaySameError: false,
      verificationFailReason: '',
      tempToken: '',
      newpassword: '',
      couldNotFindEmail: false,
      verificationCodeFail: false,
      validPasswords: false,
      signInAsGuest: false,
      guestSignUpEmail: '',
      resetPasswordErrors: [],
      resetPasswordForm: {
        newPassword: '',
        confirmNewPassword: '',
      }
    }
  },
  methods: {
    ...mapActions('auth', ['mobileLoginRequest', 'checkUsername', 'resetEmail', 'sentVerificationCode', 'resetPassword', 'registerBusinessCustomer', 'checkEmail', 'registerRequest', 'guestCheckout']),
    ...mapMutations('auth', ['userRegistered', 'registeringUser', 'registerError']),
    ForgotPassword() {
      this.newPasswordResetMessage = '',
      this.login = !this.login
    },
    Login(form) {
      this.mobileLoginRequest(form)
    },
    guestSignUp() {
      this.signInAsGuest = !this.signInAsGuest;
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    resetEmailRequest(email, e) {
      e.preventDefault();
      this.couldNotFindEmail = false;
      this.resetEmail(email)
      .then(res => {
        this.tempToken = res.data;
        this.showModal = true;     
      })
      .catch(err => {
        this.couldNotFindEmail = true;
      })
    },
    resetPasswordRequest: async function(form) { 
      await this.checkPasswordForm(form);
      if (!this.resetPasswordErrors.length) {
        this.resetPassword({new_password: form.newPassword, token: this.tempToken})
        .then(res => {
          Object.assign(this.$data, this.$options.data.call(this));
          this.newPasswordResetMessage = "You have successfully reset your password";
        })
        .catch(err => {
          this.resetPasswordErrors = [];
          this.resetPasswordErrors.push(err);
          // alert('Error resetting your password, please contact Truckxi for more information')
        })
      }
    },
    checkPasswordForm: async function(form){
      this.resetPasswordErrors = [];
      if (form.newPassword.length < 8) {
        this.resetPasswordErrors.push(this.$t('passwordLengthRequired'))
      }
      if (form.newPassword !== form.confirmNewPassword) {
        this.resetPasswordErrors.push('Your passwords do not match.');
      }
    },
    register: async function(form) {
      form.email = this.registerForm.username;
      await this.checkForm(form);
      if(!this.errors.length) {
        this.registeringUser();
        this.registerRequest(form)
        .then(res => {
          this.userRegistered();
          this.mobileLoginRequest({ username: form.username, password: form.password });
        })
        .catch( err => {
          this.registerError();
          this.errors = [];
          this.errors.push(this.$t('errorCreateAccount'));
        })
      }
    },
    businessRegister: async function(form) {
      form.full_name = this.b2bFullName;
      await this.checkBusinessRegistration(form);
      if(!this.businessErrors.length) {
        this.registerBusinessCustomer(form)
        .catch( err => {
          this.businessErrors = [];
          this.businessErrors.push(this.$t('errorCreateAccount'));
        })
      }
    }, 
    checkForm: async function (form) {
      this.errors = [];
      const usernameBeenTaken = await this.checkUsername({ username: form.username });
      if(!form.FirstName) {
      this.errors.push(this.$t('firstNameRequired'))
      };
      if(!form.LastName) {
        this.errors.push(this.$t('lastNameRequired'))
      };
      if(form.password.length < 8) {
        this.errors.push(this.$t('passwordLengthRequired'))
      }
      if(form.username.length < 5) {
        this.errors.push(this.$t('usernameLengthRequired'));
      }
      if(usernameBeenTaken.data.isTaken) {
        this.errors.push(this.$t('usernameTaken'))
      }
      if (!this.validPasswords) {
        this.errors.push('Your passwords do not match.')
      }
      if (!form.username) {
        this.errors.push(this.$t('emailRequired'));
      } else if (!this.validEmail(form.username)) {
        this.errors.push(this.$t('emailValidRequired'));
      }else {
        const res = await this.checkEmail({ email: form.username })
        if(res.data.isTaken) {
          this.errors.push(this.$t('emailIsTaken'))
        }
      } 
    },
    checkBusinessRegistration: async function(form) {
      this.businessErrors = [];
      if (!this.b2bFirstName) {
        this.businessErrors.push(this.$t('firstNameRequired'));
      };
      if(!this.b2bLastName) {
        this.businessErrors.push(this.$t('lastNameRequired'));
      };
       if(!form.business_name) {
        this.businessErrors.push(this.$t('Business Name required'))
      };
      if(!form.phone_number) {
        this.businessErrors.push(this.$t('Please enter a valid phone number.'))
      };
      if (!form.street) {
        this.businessErrors.push('Please enter a valid address');
      }
      if (!form.city) {
        this.businessErrors.push('Please enter a valid city');
      }
      if (!form.zipcode) {
        this.businessErrors.push('Please enter a valid zipcode');
      }
      if (!form.country) {
        this.businessErrors.push('Please enter a valid country');
      }
      if (!form.state) {
        this.businessErrors.push('Please enter a valid state');
      }
      if (!form.email) {
        this.businessErrors.push(this.$t('emailRequired'));
      } else if (!this.validEmail(form.email)) {
        this.businessErrors.push(this.$t('emailValidRequired'));
      } else {
        const res = await this.checkEmail({ email: form.email })
        if (res.data.isTaken) {
          this.businessErrors.push(this.$t('emailTaken'))
        }
      } 
    },
    verifyPasswords() {
      if (this.registerForm.password === this.registerForm.confirmPassword) {
        this.validPasswords = true;
      } else {
        this.validPasswords = false;
      }
    },
    checkSamePw(newPW, confirmPW) {
      if (newPW !== confirmPW) {
        this.displaySameError = true;
      } else {
        this.displaySameError = false;
      }
    },
    sendVerificationCode(code, newPW, confirmPW) {
      console.log("send", this.tempToken, code, newPW, confirmPW);
      if (newPW !== confirmPW) {
        this.displaySameError = true;
        return;
      } else {
        this.displaySameError = false;
      }
      this.verificationCodeFail = false;
      this.verificationFailReason = '';
      // if (code.length < 8) {
      //   return;
      // }
      // this.sentVerificationCode({ code, token: this.tempToken })
      // .then(res=> {
      //   this.showModal = false;
      //   this.tempToken = res.data;
      //   this.showChangeToNewPassword = true;
      // })
      // .catch(err => {
      //   this.verificationCodeFail = true
      // })

      this.resetPassword({new_password: newPW, token: this.tempToken, code: code})
        .then(res => {
          console.log("res:", res);
          Object.assign(this.$data, this.$options.data.call(this));
          alert("You have successfully reset your password");
          this.newPasswordResetMessage = "You have successfully reset your password";
        })
        .catch(err => {
          this.verificationCodeFail = true;
          console.log("ERR", err.response.data);
          this.verificationFailReason = err.response.data;
          // alert('Error resetting your password, please contact Truckxi for more information')
        })


    },
    cancelEnteringVerificationCode() {
      this.showModal = false
    },
    guestLogIn() {
      const emailBeenTaken = this.checkUsername({ username: this.guestSignUpEmail })
      .then( (response) => {
        if (!response.data.isTaken) {
          let data = {email: this.guestSignUpEmail, username: this.guestSignUpEmail}
          this.guestCheckout(data)
          .then( (res) => {
            this.mobileLoginRequest({username: this.guestSignUpEmail, password: res.data });
          })
          .catch( (err) => {
            if (err.response.data.username) {
              if (Array.isArray(err.response.data.username)) {
                err.response.data.username.map(error => {
                  this.guestCheckoutErrors.push(error)
                })
              } else {
                this.guestCheckoutErrors.push(err.response.data.username)
              }
            } else {
              this.guestCheckoutErrors.push(err);
            }
          });
        } else {
          if (!this.guestCheckoutErrors.includes('You have previously placed an order with this email. Please sign in or reset this password.')) {
            this.guestCheckoutErrors.push('You have previously placed an order with this email. Please sign in or reset this password.')
          }
        }
      })  
    }
  },
  computed: mapState({
    loginErrorMessage: state => state.auth.loginErrorMessage,
    loggingIn: state => state.auth.loggingIn,
    b2bFullName() {
      return this.b2bFirstName + ' ' + this.b2bLastName;
    },
    registering: state => state.auth.registering,
    registered: state => state.auth.registered,
  }),
}
</script>
​
<style scoped lang="less">
@import "../../assets/css/signUpModal.less";
</style>



// WEBPACK FOOTER //
// src/view/Auth/login.vue